// Notes: All signals need to be documented in our wiki/manual
// https://effectsoft.atlassian.net/wiki/spaces/r360/pages/2857959437/r360+Online+Client+Integration+API
export const SIGNAL_READY = "READY";
export const SIGNAL_PURCHASE = "PURCHASE";
export const SIGNAL_PURCHASE_COMPLETED = "PURCHASE_COMPLETED";
export const SIGNAL_PAGE_VIEW = "PAGE/VIEW";
export const SIGNAL_CART_ADD_PRODUCT = "CART/ADD_PRODUCT";
export const SIGNAL_CART_REMOVE_PRODUCT = "CART/REMOVE_PRODUCT";
export const SIGNAL_CART_EMPTY = "CART/EMPTY";
export const SIGNAL_CART_UPDATED = "CART/UPDATED";
